import React, { ComponentType, CSSProperties } from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ size?: number }>`
    line-height: 1;

    svg {
        width: ${({ size }) => size}px;
        height: ${({ size }) => size}px;

        * {
            fill: currentColor;
        }
    }
`;

Wrapper.defaultProps = {
    size: 24,
};

interface Props {
    Icon: ComponentType;
    size?: number;
    style?: CSSProperties;
}

export const CustomIcon = ({ Icon, size, style = {} }: Props) => {
    return (
        <Wrapper size={size} style={style}>
            <Icon />
        </Wrapper>
    );
};

export const withCustomIcon = (Component: ComponentType) => {
    // eslint-disable-next-line react/display-name
    return (props: {
        size?: number;
        style?: CSSProperties;
        onClick?: (event: MouseEvent) => void;
    }) => <CustomIcon {...props} Icon={Component} />;
};
